import css from './Header.module.css';
import { Link as ScrollLink, scroller } from 'react-scroll';
import logo from './img/logo.png';
import React, { useContext } from 'react';
import { MyContext } from '../MyContextProvider/MyContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const { setModal } = useContext(MyContext);
  const location = useLocation();
  const navigate = useNavigate();

  // 🔹 Универсальная функция: если не на "/", перейти, а потом проскроллить
  const handleScrollOrNavigate = (targetId, offset = 0) => (e) => {
    e.preventDefault();

    const scrollToSection = () => {
      scroller.scrollTo(targetId, {
        smooth: true,
        offset,
        duration: 1000,
      });
    };

    if (location.pathname !== '/') {
      navigate('/');
      // Подождать, пока страница загрузится, затем проскроллить
      setTimeout(scrollToSection, 400);
    } else {
      scrollToSection();
    }
  };

  return (
    <section id="header" className={css.container}>
      <div className={css.imgContainer}>
        <ScrollLink
          spy={true}
          smooth={true}
          offset={50}
          duration={1500}
          to="hero"
          className={css.imgLink}
        >
          <img src={logo} className={css.logo} id="headerLogo" />
        </ScrollLink>
      </div>

      <div className={css.buttonButger} onClick={() => setModal(true)}>
        |||
      </div>

      <div className={css.linkContainer}>
        <nav className={css.nav}>
          <a href="#heroDesc" onClick={handleScrollOrNavigate('heroDesc', -250)} className={css.link}>
            О нас
          </a>
          <a href="#work" onClick={handleScrollOrNavigate('work', -150)} className={css.link}>
            Roadmap
          </a>
          <a href="#primer" onClick={handleScrollOrNavigate('primer', -80)} className={`${css.link} ${css.nm}`}>
            Примеры работ
          </a>
          <a href="#complects" onClick={handleScrollOrNavigate('complects', 50)} className={css.link}>
            Комплекты
          </a>
          <a href="#contacts" onClick={handleScrollOrNavigate('contacts', 50)} className={css.link}>
            Контакты
          </a>         
           <a href="/documentation" className={css.link}>
            Документация
          </a>


          <span className={`${css.link} ${css.nm}`}>
            +7 <span>499</span> 714-81-64
          </span>
        </nav>
      </div>
    </section>
  );
};

export default Header;
